import { registerPlugin } from "@capacitor/core";

export interface ForceExitPlugin {
  forceExit(): Promise<void>;
}

const ForceExit = registerPlugin<ForceExitPlugin>("ForceExit");

export default ForceExit;
